export default __webpack_public_path__ + "static/media/icn-inverted-male.c35d4e9b.svg";